<template>
<!-- 售后服务 -->
    <div class="afterSale">
        <div class="saleTitle">
            <img class="pic" src="../assets/icon_touxiang@2x.png" alt="客服头像">
            <div class="text">
                <p>售后服务</p>
                <p>服务时间：周一到周五9:00~18:00</p>
            </div>
            <div class="details">
                <router-link :to="{ name: 'CustomerService' }">查看详情</router-link>
            </div>
        </div>
        <div class="saleBox">
            <div class="saleList">
                <router-link :to="{ name: 'CommonProblem' }">
                    <span>常见问题</span>
                    <img src="../assets/icon_fanhui@2x.png" alt="more">
                </router-link>

                <router-link :to="{ name: 'GZHInstructions'}">
                    <span>公众号使用说明</span>
                    <img src="../assets/icon_fanhui@2x.png" alt="more">
                </router-link>

                <router-link :to="{ name: 'AboutUs'}">
                    <span>关于我们</span>
                    <img src="../assets/icon_fanhui@2x.png" alt="more">
                </router-link>

                <router-link :to="{ name: 'LeavingMessage'}">
                    <span>咨询留言</span>
                    <img src="../assets/icon_fanhui@2x.png" alt="more">
                </router-link>

                <router-link :to="{ name: 'InstructionForUse'}">
                    <span>设备使用说明</span>
                    <img src="../assets/icon_fanhui@2x.png" alt="more">
                </router-link>
            </div>
        </div>

        <div class="telephone">
            咨询电话：18518635777
        </div>
        
    </div>
</template>

<script>
export default {
    props: {

    },
    data() {
        return {

        };
    },
    computed: {

    },
    created() {

    },
    mounted() {

    },
    watch: {

    },
    methods: {

    },
    components: {

    },
};
</script>

<style>

span {
    letter-spacing: 4px;
}

html {
    background: #f8f8f8;
}

.saleTitle {
    height: 96px;
    background: #ffffff;
    margin: 30px 0;
    padding: 28px;
    display: flex;
}

.saleTitle .pic {
    width: 94px;
    margin-right: 15px;
}

.saleTitle .text p:nth-child(2) {
    color: #666666;
    font-size: 32px;
    letter-spacing: normal;
}

.saleTitle .text p:first-of-type {
    margin-bottom: 12px;
}

.saleTitle .details{
    height: 96px;
    line-height: 96px;
    margin-left: auto;
}

.saleTitle .details a {
    color: #666666;
    font-size: 32px;
}

.saleBox {
    padding: 28px;
}

.saleList {
    border-radius: 25px;
    background: #ffffff;
    padding: 0 26px;
}

.saleList a{
    height: 118px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f0f0f0;
}

.saleList a:last-child {
    border-bottom: none;
}

.saleList img {
    height: 26px;
}

.telephone {
    padding: 28px;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/AfterSale.vue